import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Por qué cuesta esto?',
  a: 'Tu dignidad vale más que $89. Es menos que un café con postre, pero te ahorra años de terapia y humillación.'
}, {
  q: '¿Es difícil de leer?',
  a: 'Es directo. Te va a doler, pero te va a curar.'
}, {
  q: '¿Y si me escribe mientras lo leo?',
  a: 'El manual te dice exactamente qué hacer para no caer otra vez.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 px-5 bg-[#FAF5EE]" data-id="element-13">
      <div className="max-w-2xl mx-auto" data-id="element-14">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-4xl text-[#5C1A2B] mb-10 text-center" data-id="element-15">
          Preguntas que tienes
        </motion.h2>

        <div className="space-y-3" data-id="element-16">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="border border-[#E0D5C1] bg-white overflow-hidden" data-id="element-17">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full text-left px-5 py-4 flex justify-between items-center focus:outline-none gap-4" data-id="element-18">
                <span className="font-serif text-base md:text-lg text-[#2D2D2D]" data-id="element-19">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-[#C86B5E] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-20" />
              </button>
              <AnimatePresence data-id="element-21">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-22">
                    <div className="px-5 pb-4 text-sm md:text-base text-[#4A4A4A] font-light leading-relaxed" data-id="element-23">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}